module.exports = __webpack_public_path__ + "static/media/nike-eor-lost-3.0495dc64.jpg";